import script from "./SunTracker.vue?vue&type=script&setup=true&lang=ts"
export * from "./SunTracker.vue?vue&type=script&setup=true&lang=ts"

import "./SunTracker.vue?vue&type=style&index=0&id=51ea3700&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51ea3700"]])

export default __exports__